module.exports = __webpack_public_path__ + "c712a03ea07a1e49b1eb2de0252f0bc0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/addons/images/homeimage4.jpg
// module id = 1353
// module chunks = 17